import React, { useState, useEffect } from 'react';
import Notice from './Notice';
import toastManager from '../utils/toastManager';

/**
 * 全局 Toast 通知容器
 * 在應用頂層顯示所有 toast 通知
 */
const GlobalToastContainer = () => {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    // 監聽 toast 管理器的通知變化
    const handleNoticesChange = (newNotices) => {
      setNotices(newNotices);
    };

    toastManager.addListener(handleNoticesChange);

    // 清理監聽器
    return () => {
      toastManager.removeListener(handleNoticesChange);
    };
  }, []);

  const removeNotice = (id) => {
    toastManager.remove(id);
  };

  if (notices.length === 0) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      maxWidth: '400px',
      width: '100%'
    }}>
      {notices.map(notice => (
        <Notice
          key={notice.id}
          type={notice.type}
          message={notice.message}
          onClose={() => removeNotice(notice.id)}
        />
      ))}
    </div>
  );
};

export default GlobalToastContainer;
